import * as React from 'react';
import { Nav } from 'react-bootstrap';
import { NavWrapper } from '../action-center/styles';
import { NavItemWrapper } from '../styles';
import ReactHtmlParser from 'react-html-parser';
import { OrganType } from '@nkr/enums/organ-type';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IProps {
    activeKey: string,
    tabText: string,
    centerId: number,
    centerAlias: string,
    onTabSelect: (key: string) => void
}

const BillingNav = (props: IProps) => {
    const handleSelect = (e: React.FormEvent<Nav>) => {
        props.onTabSelect(e['eventKey']);
    };

    const { app } = useAppHookContext();
    const isNkr = app.site.organType == OrganType.Kidney;
    const hrefPrefix = `/center/${props.centerId}/billing`;
    const tabWidth = '230';

    const isAccountsReceivable = ['ACCOUNTS-RECEIVABLE'].indexOf(props.activeKey) >= 0;
    const isAccountsReceivableOpo = ['ACCOUNTS-RECEIVABLE-OPO'].indexOf(props.activeKey) >= 0;
    const isAccountsPayableTotal = ['ACCOUNTS-PAYABLE-TOTAL'].indexOf(props.activeKey) >= 0;
    const isTotalStatement = ['ACCOUNTS-TOTAL-STATEMENT'].indexOf(props.activeKey) >= 0;


    const isBillDonorCenter = ['PENDING', 'BILLED-BY-CENTER', 'NOT-BILLED', 'BILLED-MANUALLY', 'SEARCH', 'VIEW-EDIT', 'VIEW-CHARGES'].indexOf(props.activeKey) >= 0;
    const isBillRecipientCenter = ['PAY-THROUGH-NKR', 'BILLED-TO-CENTER', 'PAYMENT-SUBMITTED-BY', 'PAYMENT-SUBMITTED-TO', 'PAY', 'PAYMENT-VIEW-EDIT'].indexOf(props.activeKey) >= 0;


    return (
        <>
            <NavWrapper bsStyle='tabs' activeKey={props.activeKey} height='initial'>
                {isNkr && (<>
                    <NavItemWrapper active={isAccountsReceivable} href={hrefPrefix + '/accounts-receivable'} tabWidth={tabWidth}>
                        CCB Accounts Receivable
                </NavItemWrapper>

                    <NavItemWrapper active={isAccountsReceivableOpo} href={hrefPrefix + '/accounts-receivable-opo'} tabWidth={tabWidth}>
                        Organ Packaging Accounts Receivable
                </NavItemWrapper>
                </>)}

                <NavItemWrapper active={isAccountsPayableTotal} href={hrefPrefix + '/accounts-payable-total'} tabWidth={tabWidth}>
                    Total Accounts Payable
                </NavItemWrapper>

                <NavItemWrapper active={isTotalStatement} href={hrefPrefix + '/accounts-total-statement'} tabWidth={tabWidth}>
                    Total Statement of Accounts
                </NavItemWrapper>

                {/* {isBillDonorCenter && (
                    <>
                        <NavItemWrapper active={props.activeKey == 'PENDING'} href={hrefPrefix + '/pending'} tabWidth={tabWidth}>
                            Pending Billing
                        </NavItemWrapper>

                        <NavItemWrapper active={props.activeKey == 'BILLED-BY-CENTER'} href={hrefPrefix + '/billed-by-center'} tabWidth={tabWidth}>
                            Billed by {props.centerAlias}
                        </NavItemWrapper>

                        <NavItemWrapper active={props.activeKey == 'NOT-BILLED'} href={hrefPrefix + '/not-billed'} tabWidth={tabWidth}>
                            Not Billed
                        </NavItemWrapper>

                        <NavItemWrapper active={props.activeKey == 'BILLED-MANUALLY'} href={hrefPrefix + '/billed-manually'} tabWidth={tabWidth}>
                            Billed Manually
                        </NavItemWrapper>

                        <NavItemWrapper active={props.activeKey == 'SEARCH'} href={hrefPrefix + '/search'} tabWidth={tabWidth}>
                            Search
                        </NavItemWrapper>

                        {props.activeKey.toUpperCase() == 'VIEW-EDIT' && (
                            <>
                                <NavItemWrapper active={props.activeKey == 'VIEW-EDIT'} tabWidth={tabWidth}>
                                    {props.tabText}
                                </NavItemWrapper>
                            </>
                        )}

                        {props.activeKey.toUpperCase() == 'VIEW-CHARGES' && (
                            <>
                                <NavItemWrapper active={props.activeKey == 'VIEW-CHARGES'} tabWidth={tabWidth}>
                                    {props.tabText}
                                </NavItemWrapper>
                            </>
                        )}
                    </>
                )} */}

                {/* {isBillRecipientCenter && (
                    <>
                        <NavItemWrapper active={props.activeKey == 'PAY-THROUGH-NKR'} href={hrefPrefix + '/pay-through-nkr'} tabWidth={tabWidth}>
                            Pay Centers Through NKR
                        </NavItemWrapper>

                        <NavItemWrapper active={props.activeKey == 'BILLED-TO-CENTER'} href={hrefPrefix + '/billed-to-center'} tabWidth={tabWidth}>
                            Billed to {props.centerAlias}
                        </NavItemWrapper>

                        <NavItemWrapper active={props.activeKey == 'PAYMENT-SUBMITTED-BY'} href={hrefPrefix + '/payment-submitted-by'} tabWidth={tabWidth}>
                            Billing Requests
                        </NavItemWrapper>

                        {props.activeKey.toUpperCase() == 'PAY' && (
                            <>
                                <NavItemWrapper active={props.activeKey == 'PAY'} tabWidth={tabWidth}>
                                    {ReactHtmlParser(props.tabText)}
                                </NavItemWrapper>
                            </>
                        )}

                        {props.activeKey.toUpperCase() == 'PAYMENT-VIEW-EDIT' && (
                            <>
                                <NavItemWrapper active={props.activeKey == 'PAYMENT-VIEW-EDIT'} tabWidth={tabWidth}>
                                    {ReactHtmlParser(props.tabText)}
                                </NavItemWrapper>
                            </>
                        )}
                    </>
                )} */}
            </NavWrapper>
        </>
    );
}

export default BillingNav;